import React from 'react';

const SVGComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    id="Capa_1"
    enableBackground="new 0 0 511.782 511.782"
    height={512}
    viewBox="0 0 511.782 511.782"
    width={512}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <path
          d="m7.615 511.782c-1.949 0-3.898-.744-5.384-2.23-2.974-2.974-2.974-7.795 0-10.769l66.607-66.607c2.974-2.974 7.795-2.974 10.769 0s2.974 7.795 0 10.769l-66.607 66.607c-1.487 1.486-3.436 2.23-5.385 2.23z"
          fill="#435f6d"
        />
      </g>
      <path
        d="m92.226 455.565-36.009-36.009c-7.938-7.938-7.938-20.808 0-28.747l25.619-25.619 64.756 64.756-25.619 25.619c-7.938 7.938-20.809 7.938-28.747 0z"
        fill="#99afc6"
      />
      <path
        d="m146.589 429.943-25.617 25.617c-7.94 7.94-20.807 7.94-28.747 0l-17.243-17.243c7.94 7.94 20.807 7.94 28.747 0l25.617-25.617z"
        fill="#7e9cb7"
      />
      <path
        d="m155.317 445.369-88.904-88.904c-4.744-4.744-4.744-12.435 0-17.179l218.111-218.111 106.082 106.083-218.11 218.111c-4.744 4.744-12.435 4.744-17.179 0z"
        fill="#bcf7e7"
      />
      <path
        d="m390.599 227.258-218.105 218.106c-4.746 4.746-12.434 4.746-17.18 0l-17.243-17.243c4.746 4.746 12.434 4.746 17.18 0l218.106-218.106z"
        fill="#abefd9"
      />
      <path
        d="m155.317 445.369-88.904-88.904c-4.744-4.744-4.744-12.435 0-17.179l110.182-110.182 106.083 106.082-110.182 110.183c-4.744 4.744-12.435 4.744-17.179 0z"
        fill="#ffcc5a"
      />
      <path
        d="m319.044 43.412h53.639v245.011h-53.639z"
        fill="#5ee2c5"
        transform="matrix(.707 .707 -.707 .707 218.623 -195.967)"
      />
      <path
        d="m341.936 52.894h26.82v245.011h-26.82z"
        fill="#00d3b4"
        transform="matrix(.707 .707 -.707 .707 228.105 -199.894)"
      />
      <path
        d="m169.427 246.411h150.023v41.865h-150.023z"
        fill="#99afc6"
        transform="matrix(.707 .707 -.707 .707 260.635 -94.541)"
      />
      <path
        d="m276.661 290.829h24.391v41.865h-24.391z"
        fill="#7e9cb7"
        transform="matrix(.707 .707 -.707 .707 305.053 -112.939)"
      />
      <g>
        <g>
          <path
            d="m206.645 321.514c-1.919 0-3.839-.732-5.303-2.197l-31.167-31.167c-2.929-2.929-2.929-7.678 0-10.606 2.929-2.929 7.678-2.93 10.606 0l31.167 31.167c2.929 2.929 2.929 7.678 0 10.606-1.464 1.465-3.384 2.197-5.303 2.197z"
            fill="#99afc6"
          />
        </g>
        <g>
          <path
            d="m167.276 336.471c-1.919 0-3.839-.732-5.303-2.197l-18.96-18.96c-2.929-2.929-2.929-7.678 0-10.606 2.929-2.929 7.678-2.929 10.606 0l18.96 18.96c2.929 2.929 2.929 7.678 0 10.606-1.464 1.464-3.384 2.197-5.303 2.197z"
            fill="#99afc6"
          />
        </g>
        <g>
          <path
            d="m151.675 376.485c-1.919 0-3.839-.732-5.303-2.197l-31.167-31.167c-2.929-2.929-2.929-7.678 0-10.606 2.929-2.929 7.678-2.929 10.606 0l31.167 31.167c2.929 2.929 2.929 7.678 0 10.606-1.465 1.464-3.384 2.197-5.303 2.197z"
            fill="#99afc6"
          />
        </g>
      </g>
      <path
        d="m282.674 335.183-110.18 110.181c-4.746 4.746-12.434 4.746-17.18 0l-17.243-17.243c4.746 4.746 12.434 4.746 17.18 0l110.18-110.181z"
        fill="#ffb509"
      />
      <path
        d="m399.42 236.071-123.71-123.71c-3.814-3.814-3.814-9.998 0-13.812l22.954-22.954c3.814-3.814 9.998-3.814 13.812 0l123.71 123.71c3.814 3.814 3.814 9.998 0 13.812l-22.954 22.954c-3.813 3.814-9.997 3.814-13.812 0z"
        fill="#99afc6"
      />
      <path
        d="m436.193 213.119-22.955 22.955c-3.817 3.817-10.007 3.817-13.823 0l-18.966-18.967c3.817 3.817 10.007 3.817 13.823 0l22.955-22.955c3.808-3.808 3.808-9.998-.009-13.814l18.967 18.966c3.815 3.817 3.815 10.007.008 13.815z"
        fill="#7e9cb7"
      />
      <path
        d="m479.404 137.296-104.918-104.918c-4.048-4.048-4.048-10.611 0-14.659l14.684-14.683c4.048-4.048 10.611-4.048 14.659 0l104.918 104.918c4.048 4.048 4.048 10.611 0 14.659l-14.684 14.684c-4.049 4.047-10.611 4.047-14.659-.001z"
        fill="#435f6d"
      />
      <path
        d="m508.747 122.608-14.69 14.69c-4.042 4.042-10.611 4.042-14.653 0l-17.252-17.252c4.051 4.051 10.62 4.051 14.662.009l14.69-14.69c4.042-4.042 4.042-10.611-.009-14.662l17.252 17.252c4.042 4.042 4.042 10.611 0 14.653z"
        fill="#334c59"
      />
    </g>
  </svg>
);
export default SVGComponent;
